import React, { useEffect, useState } from 'react';
import {
    FormControl, FormControlLabel, FormHelperText, FormLabel, Grid,
    IconButton, Radio, RadioGroup, Typography, Checkbox, MenuItem,
    ListItemIcon, ListItemText, Button, Select, Box, TextField
} from '@material-ui/core';
import {
    generalDiseases, behavioralDiseases, cardiovascularDiseases,
    endocrineDiseases, gastrointestinalDiseases, hematologicDiseases,
    immunologicDiseases, neurologicDiseases, oncologicDiseases,
    psychiatricDiseases, respiratoryDiseases, reproductiveDiseases, familyHeirs
} from '../../../data/db';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import { AppSelect } from './ProviderInputComponents';
import { useTranslation } from "react-i18next";
import useStyles from "./Common.style";
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Minimize from '@material-ui/icons/Minimize';

const FamilyHistory = props => {
    const classes = useStyles();
    const { t } = useTranslation();
    const MenuProps = {
        PaperProps: {
            style: {
                width: 250
            }
        },
        getContentAnchorEl: null,
        anchorOrigin: {
            vertical: "bottom",
            horizontal: "center"
        },
        transformOrigin: {
            vertical: "top",
            horizontal: "center"
        },
        variant: "menu"
    };

    const [autoUpdate, setAutoUpdate] = useState(false);
    const [expandedPanel, setExpandedPanel] = useState(false);
    const handleAccordionChange = (panel) => (event, isExpanded) => {
        setExpandedPanel(isExpanded ? panel : false);
    };

    useEffect(() => {
        if (props.submitted) props.validator.showMessages();
        props.validator.purgeFields();
        setAutoUpdate(!autoUpdate);
    }, [props.submitted, props.validator, props.fhGeneralDiseases,
    props.fhBehavioral, props.fhCardiovascular, props.fhEndocrine,
    props.fhGastrointestinal, props.fhHematologic, props.fhImmunologic,
    props.fhNeurologic, props.fhOncologic, props.fhPsychiatric,
    props.fhRespiratory, props.fhReproductive]);

    return (
        <Grid container className={classes.questionnaireContainer}>
            <Accordion style={{width:"100%"}} onChange={handleAccordionChange('panel1')}>
                <AccordionSummary
                    expandIcon={
                        expandedPanel ? <Minimize /> :
                            <AddIcon />
                    }
                    className={classes.accordionMarginStyle}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <Typography variant="h5">Family History</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Grid container xs={12}>
                        {/* General */}
                        {props.fhGeneralDiseases?.map((general, i) => {
                            return (
                                <Grid container style={{ paddingTop: 10 }} spacing={1} className={classes.questionnaireItem} key={i} >
                                    <Grid item xs={12} className={classes.questionnaireItemHeader}>
                                        <span>{t('common.substantive.fhGeneralAssessmentDisease')} #{i + 1}</span>
                                        <IconButton aria-label="delete" color="inherit" onClick={props.onFhRemove('generalAssessment', i)}>
                                            <DeleteIcon />
                                        </IconButton>
                                    </Grid>
                                    <Grid item xl={12} md={12} className={classes.appSelectGridItem}>
                                        <AppSelect
                                            id={`general${i + 1}`}
                                            value={general.disease}
                                            label="Condition"
                                            items={[...generalDiseases]}
                                            onChange={e => props.onFhDataChange('generalAssessment', i, 'disease', e.target.value)()}
                                            fullWidth
                                            error={props.submitted && !props.validator.fieldValid(`general_#${i + 1}_disease`)}
                                            helperText={props.validator.message(`general_#${i + 1}_disease`, general.disease, 'required')}
                                        />
                                    </Grid>
                                    <Box style={{ width: "100%" }}  display={general.disease === 'None' || general.disease === '' ? 'none' : 'block'}>
                                        <Grid item xs={12}>
                                            <Typography variant="h6">Family Members</Typography>
                                            <FormControl   variant="outlined"  style={{width:"100%"}}>
                                                <Select
                                                    style={{width:"100%"}}
                                                    multiple
                                                    value={general.heirs}
                                                    onChange={e => props.onFhDataChange('generalAssessment', i, 'heirs', e.target.value)()}
                                                    renderValue={(selected) => selected.join(", ")}
                                                    MenuProps={MenuProps}
                                                    error={props.submitted && !props.validator.fieldValid(`general_#${i + 1}_heirs`)}
                                                >
                                                    {familyHeirs.map((option) => (
                                                        <MenuItem key={option} value={option}>
                                                            <ListItemIcon>
                                                                <Checkbox color="primary" checked={general.heirs.indexOf(option) > -1} />
                                                            </ListItemIcon>
                                                            <ListItemText primary={option} />
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                                <FormHelperText error>
                                                    {props.validator.message(`general_#${i + 1}_heirs`, general.heirs, 'required')}
                                                </FormHelperText>
                                            </FormControl>
                                            <FormControl
                                                component="fieldset"
                                                error={props.submitted && !props.validator.fieldValid(`general_#${i + 1}_self`)}>
                                                <FormLabel className={classes.formLabelStyle}>{`${t('common.substantive.self')}*`}</FormLabel>
                                                <RadioGroup row
                                                    aria-label="Self"
                                                    value={general.self}
                                                    onChange={e => props.onFhDataChange('generalAssessment', i, 'self', e.target.value)()}
                                                >
                                                    {['Yes', 'No'].map((answer, i) =>
                                                        <FormControlLabel key={i} value={answer} control={<Radio color="primary" />} label={answer} />
                                                    )}
                                                </RadioGroup>
                                                <FormHelperText>
                                                    {props.validator.message(`general_#${i + 1}_self`, general.self, 'required')}
                                                </FormHelperText>
                                            </FormControl>
                                        </Grid>
                                    </Box>
                                </Grid>
                            )
                        })}
                        <Grid item xs={12} style={{ marginBottom: 15 }}>
                            <Button
                                fullWidth
                                variant="contained"
                                color="secondary"
                                startIcon={<AddIcon />}
                                onClick={props.onFhAdd('generalAssessment')}
                            >
                                {t('module.provider.addPatient.form.button.addGeneralAssessment')}
                            </Button>
                        </Grid>


                        {/* behavior */}
                        {props.fhBehavioral?.map((behavioral, i) => {
                            return (
                                <Grid container style={{ paddingTop: 10 }} spacing={1} className={classes.questionnaireItem} key={i} >
                                    <Grid item xs={12} className={classes.questionnaireItemHeader}>
                                        <span>{t('common.substantive.fhBehavioralAssessmentDisease')} #{i + 1}</span>
                                        <IconButton aria-label="delete" color="inherit" onClick={props.onFhRemove('behavioral', i)}>
                                            <DeleteIcon />
                                        </IconButton>
                                    </Grid>
                                    <Grid item xl={12} md={12} className={classes.appSelectGridItem}>
                                        <AppSelect
                                            id={`behavioral${i + 1}`}
                                            value={behavioral.disease}
                                            label="Condition"
                                            fullWidth
                                            items={[...behavioralDiseases]}
                                            onChange={e => props.onFhDataChange('behavioral', i, 'disease', e.target.value)()}
                                            error={props.submitted && !props.validator.fieldValid(`behavioral_#${i + 1}_disease`)}
                                            helperText={props.validator.message(`behavioral_#${i + 1}_disease`, behavioral.disease, 'required')}
                                        />
                                    </Grid>
                                    <Box style={{ width: "100%" }} display={behavioral.disease === 'None' || behavioral.disease === '' ? 'none' : 'block'}>
                                        <Grid item xs={12}>
                                            <Typography variant="h6">Family Members</Typography>
                                            <FormControl variant="outlined" fullWidth>
                                                <Select
                                                    multiple
                                                    value={behavioral.heirs}
                                                    onChange={e => props.onFhDataChange('behavioral', i, 'heirs', e.target.value)()}
                                                    renderValue={(selected) => selected.join(", ")}
                                                    MenuProps={MenuProps}
                                                    error={props.submitted && !props.validator.fieldValid(`behavioral_#${i + 1}_heirs`)}>
                                                    {familyHeirs.map((option) => (
                                                        <MenuItem key={option} value={option}>
                                                            <ListItemIcon>
                                                                <Checkbox color="primary" checked={behavioral.heirs.indexOf(option) > -1} />
                                                            </ListItemIcon>
                                                            <ListItemText primary={option} />
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                                <FormHelperText error>
                                                    {props.validator.message(`behavioral_#${i + 1}_heirs`, behavioral.heirs, 'required')}
                                                </FormHelperText>
                                            </FormControl>
                                            <FormControl
                                                component="fieldset"
                                                error={props.submitted && !props.validator.fieldValid(`behavioral_#${i + 1}_self`)}>
                                                <FormLabel className={classes.formLabelStyle}>{`${t('common.substantive.self')}*`}</FormLabel>
                                                <RadioGroup row
                                                    aria-label="Self"
                                                    value={behavioral.self}
                                                    onChange={e => props.onFhDataChange('behavioral', i, 'self', e.target.value)()}
                                                >
                                                    {['Yes', 'No'].map((answer, i) =>
                                                        <FormControlLabel key={i} value={answer} control={<Radio color="primary" />} label={answer} />
                                                    )}
                                                </RadioGroup>
                                                <FormHelperText>
                                                    {props.validator.message(`behavioral_#${i + 1}_self`, behavioral.self, 'required')}
                                                </FormHelperText>
                                            </FormControl>
                                        </Grid>
                                    </Box>
                                </Grid>
                            )
                        })}
                        <Grid item xs={12} style={{ marginBottom: 15 }}>
                            <Button
                                fullWidth
                                variant="contained"
                                color="secondary"
                                startIcon={<AddIcon />}
                                onClick={props.onFhAdd('behavioral')}
                            >
                                {t('module.provider.addPatient.form.button.addBehavioralAssessment')}
                            </Button>
                        </Grid>


                        {/* cardiovascular */}
                        {props.fhCardiovascular?.map((cardiovascular, i) => {
                            return (
                                <Grid container style={{ paddingTop: 10 }} spacing={1} className={classes.questionnaireItem} key={i}>
                                    <Grid item xs={12} className={classes.questionnaireItemHeader}>
                                        <span>{t('common.substantive.fhCardiovascularAssessmentDisease')} #{i + 1}</span>
                                        <IconButton aria-label="delete" color="inherit" onClick={props.onFhRemove('cardiovascular', i)} >
                                            <DeleteIcon />
                                        </IconButton>
                                    </Grid>
                                    <Grid item xl={12} md={12} className={classes.appSelectGridItem}>
                                        <AppSelect
                                            id={`cardiovascular${i + 1}`}
                                            value={cardiovascular.disease}
                                            label="Condition"
                                            items={[...cardiovascularDiseases]}
                                            onChange={e => props.onFhDataChange('cardiovascular', i, 'disease', e.target.value)()}
                                            error={props.submitted && !props.validator.fieldValid(`cardiovascular_#${i + 1}_disease`)}
                                            helperText={props.validator.message(`cardiovascular_#${i + 1}_disease`, cardiovascular.disease, 'required')}
                                            fullWidth
                                        />
                                    </Grid>
                                    <Box style={{ width: "100%" }} display={cardiovascular.disease === 'None' || cardiovascular.disease === '' ? 'none' : 'block'}>
                                        <Grid item xs={12}>
                                            <Typography variant="h6">Family Members</Typography>
                                            <FormControl variant="outlined" fullWidth>
                                                <Select
                                                    multiple
                                                    value={cardiovascular.heirs}
                                                    onChange={e => props.onFhDataChange('cardiovascular', i, 'heirs', e.target.value)()}
                                                    renderValue={(selected) => selected.join(", ")}
                                                    MenuProps={MenuProps}
                                                    error={props.submitted && !props.validator.fieldValid(`cardiovascular_#${i + 1}_heirs`)}>
                                                    {familyHeirs.map((option) => (
                                                        <MenuItem key={option} value={option}>
                                                            <ListItemIcon>
                                                                <Checkbox color="primary" checked={cardiovascular.heirs.indexOf(option) > -1} />
                                                            </ListItemIcon>
                                                            <ListItemText primary={option} />
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                                <FormHelperText error>
                                                    {props.validator.message(`cardiovascular_#${i + 1}_heirs`, cardiovascular.heirs, 'required')}
                                                </FormHelperText>
                                            </FormControl>
                                            <FormControl
                                                component="fieldset"
                                                error={props.submitted && !props.validator.fieldValid(`cardiovascular_#${i + 1}_self`)}>
                                                <FormLabel className={classes.formLabelStyle}>{`${t('common.substantive.self')}*`}</FormLabel>
                                                <RadioGroup row
                                                    aria-label="Self"
                                                    value={cardiovascular.self}
                                                    onChange={e => props.onFhDataChange('cardiovascular', i, 'self', e.target.value)()}
                                                >
                                                    {['Yes', 'No'].map((answer, i) =>
                                                        <FormControlLabel key={i} value={answer} control={<Radio color="primary" />} label={answer} />
                                                    )}
                                                </RadioGroup>
                                                <FormHelperText>
                                                    {props.validator.message(`cardiovascular_#${i + 1}_self`, cardiovascular.self, 'required')}
                                                </FormHelperText>
                                            </FormControl>
                                        </Grid>
                                    </Box>
                                </Grid>
                            )
                        })}
                        <Grid item xs={12} style={{ marginBottom: 15 }}>
                            <Button
                                fullWidth
                                variant="contained"
                                color="secondary"
                                startIcon={<AddIcon />}
                                onClick={props.onFhAdd('cardiovascular')}
                            >
                                {t('module.provider.addPatient.form.button.addCardiovascularAssessment')}
                            </Button>
                        </Grid>


                        {/* endocrine */}
                        {props.fhEndocrine?.map((endocrine, i) => {
                            return (
                                <Grid container style={{ paddingTop: 10 }} spacing={1} className={classes.questionnaireItem} key={i}>
                                    <Grid item xs={12} className={classes.questionnaireItemHeader}>
                                        <span>{t('common.substantive.fhEndocrineAssessmentDisease')} #{i + 1}</span>
                                        <IconButton aria-label="delete" color="inherit" onClick={props.onFhRemove('endocrine', i)} >
                                            <DeleteIcon />
                                        </IconButton>
                                    </Grid>
                                    <Grid item xl={12} md={12} className={classes.appSelectGridItem}>
                                        <AppSelect
                                            id={`endocrine${i + 1}`}
                                            value={endocrine.disease}
                                            label="Condition"
                                            items={[...endocrineDiseases]}
                                            onChange={e => props.onFhDataChange('endocrine', i, 'disease', e.target.value)()}
                                            error={props.submitted && !props.validator.fieldValid(`endocrine_#${i + 1}_disease`)}
                                            helperText={props.validator.message(`endocrine_#${i + 1}_disease`, endocrine.disease, 'required')}
                                            fullWidth
                                        />
                                    </Grid>
                                    <Box style={{ width: "100%" }} display={endocrine.disease === 'None' || endocrine.disease === '' ? 'none' : 'block'}>
                                        <Grid item xs={12}>
                                            <Typography variant="h6">Family Members</Typography>
                                            <FormControl variant="outlined" fullWidth>
                                                <Select
                                                    multiple
                                                    value={endocrine.heirs}
                                                    onChange={e => props.onFhDataChange('endocrine', i, 'heirs', e.target.value)()}
                                                    renderValue={(selected) => selected.join(", ")}
                                                    MenuProps={MenuProps}
                                                    error={props.submitted && !props.validator.fieldValid(`endocrine_#${i + 1}_heirs`)}>
                                                    {familyHeirs.map((option) => (
                                                        <MenuItem key={option} value={option}>
                                                            <ListItemIcon>
                                                                <Checkbox color="primary" checked={endocrine.heirs.indexOf(option) > -1} />
                                                            </ListItemIcon>
                                                            <ListItemText primary={option} />
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                                <FormHelperText error>
                                                    {props.validator.message(`endocrine_#${i + 1}_heirs`, endocrine.heirs, 'required')}
                                                </FormHelperText>
                                            </FormControl>
                                            <FormControl
                                                component="fieldset"
                                                error={props.submitted && !props.validator.fieldValid(`endocrine_#${i + 1}_self`)}>
                                                <FormLabel className={classes.formLabelStyle}>{`${t('common.substantive.self')}*`}</FormLabel>
                                                <RadioGroup row
                                                    aria-label="Self"
                                                    value={endocrine.self}
                                                    onChange={e => props.onFhDataChange('endocrine', i, 'self', e.target.value)()}
                                                >
                                                    {['Yes', 'No'].map((answer, i) =>
                                                        <FormControlLabel key={i} value={answer} control={<Radio color="primary" />} label={answer} />
                                                    )}
                                                </RadioGroup>
                                                <FormHelperText>
                                                    {props.validator.message(`endocrine_#${i + 1}_self`, endocrine.self, 'required')}
                                                </FormHelperText>
                                            </FormControl>
                                        </Grid>
                                    </Box>
                                </Grid>
                            )
                        })}
                        <Grid item xs={12} style={{ marginBottom: 15 }}>
                            <Button
                                fullWidth
                                variant="contained"
                                onClick={props.onFhAdd('endocrine')}
                                color="secondary"
                                startIcon={<AddIcon />}
                            >
                                {t('module.provider.addPatient.form.button.addEndocrineAssessment')}
                            </Button>
                        </Grid>


                        {/* gastrointestinal */}
                        {props.fhGastrointestinal?.map((gastrointestinal, i) => {
                            return (
                                <Grid container style={{ paddingTop: 10 }} spacing={1} className={classes.questionnaireItem} key={i}>
                                    <Grid item xs={12} className={classes.questionnaireItemHeader}>
                                        <span>{t('common.substantive.fhGastrointestinalAssessmentDisease')} #{i + 1}</span>
                                        <IconButton aria-label="delete" color="inherit" onClick={props.onFhRemove('gastrointestinal', i)} >
                                            <DeleteIcon />
                                        </IconButton>
                                    </Grid>
                                    <Grid item xs={12} md={12} className={classes.appSelectGridItem}>
                                        <AppSelect
                                            id={`gastrointestinal${i + 1}`}
                                            value={gastrointestinal.disease}
                                            label="Condition"
                                            items={[...gastrointestinalDiseases]}
                                            onChange={e => props.onFhDataChange('gastrointestinal', i, 'disease', e.target.value)()}
                                            error={props.submitted && !props.validator.fieldValid(`gastrointestinal_#${i + 1}_disease`)}
                                            helperText={props.validator.message(`gastrointestinal_#${i + 1}_disease`, gastrointestinal.disease, 'required')}
                                            fullWidth
                                        />
                                    </Grid>
                                    <Box style={{ width: "100%" }} display={gastrointestinal.disease === 'None' || gastrointestinal.disease === '' ? 'none' : 'block'}>
                                        <Grid item xs={12}>
                                            <Typography variant="h6">Family Members</Typography>
                                            <FormControl variant="outlined" fullWidth>
                                                <Select
                                                    multiple
                                                    value={gastrointestinal.heirs}
                                                    onChange={e => props.onFhDataChange('gastrointestinal', i, 'heirs', e.target.value)()}
                                                    renderValue={(selected) => selected.join(", ")}
                                                    MenuProps={MenuProps}
                                                    error={props.submitted && !props.validator.fieldValid(`gastrointestinal_#${i + 1}_heirs`)}>
                                                    {familyHeirs.map((option) => (
                                                        <MenuItem key={option} value={option}>
                                                            <ListItemIcon>
                                                                <Checkbox color="primary" checked={gastrointestinal.heirs.indexOf(option) > -1} />
                                                            </ListItemIcon>
                                                            <ListItemText primary={option} />
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                                <FormHelperText error>
                                                    {props.validator.message(`gastrointestinal_#${i + 1}_heirs`, gastrointestinal.heirs, 'required')}
                                                </FormHelperText>
                                            </FormControl>
                                            <FormControl
                                                component="fieldset"
                                                error={props.submitted && !props.validator.fieldValid(`gastrointestinal_#${i + 1}_self`)}>
                                                <FormLabel className={classes.formLabelStyle}>{`${t('common.substantive.self')}*`}</FormLabel>
                                                <RadioGroup row
                                                    aria-label="Self"
                                                    value={gastrointestinal.self}
                                                    onChange={e => props.onFhDataChange('gastrointestinal', i, 'self', e.target.value)()}
                                                >
                                                    {['Yes', 'No'].map((answer, i) =>
                                                        <FormControlLabel key={i} value={answer} control={<Radio color="primary" />} label={answer} />
                                                    )}
                                                </RadioGroup>
                                                <FormHelperText>
                                                    {props.validator.message(`gastrointestinal_#${i + 1}_self`, gastrointestinal.self, 'required')}
                                                </FormHelperText>
                                            </FormControl>
                                        </Grid>
                                    </Box>
                                </Grid>
                            )
                        })}
                        <Grid item xs={12} style={{ marginBottom: 15 }}>
                            <Button
                                fullWidth
                                variant="contained"
                                onClick={props.onFhAdd('gastrointestinal')}
                                color="secondary"
                                startIcon={<AddIcon />}
                            >
                                {t('module.provider.addPatient.form.button.addGastrointestinalAssessment')}
                            </Button>
                        </Grid>


                        {/* hematologic */}
                        {props.fhHematologic?.map((hematologic, i) => {
                            return (
                                <Grid container style={{ paddingTop: 10 }} spacing={1} className={classes.questionnaireItem} key={i}>
                                    <Grid item xs={12} className={classes.questionnaireItemHeader}>
                                        <span>{t('common.substantive.fhHematologicAssessmentDisease')} #{i + 1}</span>
                                        <IconButton aria-label="delete" color="inherit" onClick={props.onFhRemove('hematologic', i)} >
                                            <DeleteIcon />
                                        </IconButton>
                                    </Grid>
                                    <Grid item xs={12} md={12} className={classes.appSelectGridItem}>
                                        <AppSelect
                                            id={`hematologic${i + 1}`}
                                            label="Condition"
                                            fullWidth
                                            value={hematologic.disease}
                                            items={[...hematologicDiseases]}
                                            onChange={e => props.onFhDataChange('hematologic', i, 'disease', e.target.value)()}
                                            error={props.submitted && !props.validator.fieldValid(`hematologic_#${i + 1}_disease`)}
                                            helperText={props.validator.message(`hematologic_#${i + 1}_disease`, hematologic.disease, 'required')}
                                        />
                                    </Grid>
                                    <Box style={{ width: "100%" }} display={hematologic.disease === 'None' || hematologic.disease === '' ? 'none' : 'block'}>
                                        <Grid item xs={12}>
                                            <Typography variant="h6">Family Members</Typography>
                                            <FormControl variant="outlined" fullWidth>
                                                <Select
                                                    multiple
                                                    value={hematologic.heirs}
                                                    onChange={e => props.onFhDataChange('hematologic', i, 'heirs', e.target.value)()}
                                                    renderValue={(selected) => selected.join(", ")}
                                                    MenuProps={MenuProps}
                                                    error={props.submitted && !props.validator.fieldValid(`hematologic_#${i + 1}_heirs`)}>
                                                    {familyHeirs.map((option) => (
                                                        <MenuItem key={option} value={option}>
                                                            <ListItemIcon>
                                                                <Checkbox color="primary" checked={hematologic.heirs.indexOf(option) > -1} />
                                                            </ListItemIcon>
                                                            <ListItemText primary={option} />
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                                <FormHelperText error>
                                                    {props.validator.message(`hematologic_#${i + 1}_heirs`, hematologic.heirs, 'required')}
                                                </FormHelperText>
                                            </FormControl>
                                            <FormControl
                                                component="fieldset"
                                                error={props.submitted && !props.validator.fieldValid(`hematologic_#${i + 1}_self`)}>
                                                <FormLabel className={classes.formLabelStyle}>{`${t('common.substantive.self')}*`}</FormLabel>
                                                <RadioGroup row
                                                    aria-label="Self"
                                                    value={hematologic.self}
                                                    onChange={e => props.onFhDataChange('hematologic', i, 'self', e.target.value)()}
                                                >
                                                    {['Yes', 'No'].map((answer, i) =>
                                                        <FormControlLabel key={i} value={answer} control={<Radio color="primary" />} label={answer} />
                                                    )}
                                                </RadioGroup>
                                                <FormHelperText>
                                                    {props.validator.message(`hematologic_#${i + 1}_self`, hematologic.self, 'required')}
                                                </FormHelperText>
                                            </FormControl>
                                        </Grid>
                                    </Box>
                                </Grid>
                            )
                        })}
                        <Grid item xs={12} style={{ marginBottom: 15 }}>
                            <Button
                                fullWidth
                                variant="contained"
                                onClick={props.onFhAdd('hematologic')}
                                color="secondary"
                                startIcon={<AddIcon />}
                            >
                                {t('module.provider.addPatient.form.button.addHematologicAssessment')}
                            </Button>
                        </Grid>


                        {/* immunologic */}
                        {props.fhImmunologic?.map((immunologic, i) => {
                            return (
                                <Grid container style={{ paddingTop: 10 }} spacing={1} className={classes.questionnaireItem} key={i}>
                                    <Grid item xs={12} className={classes.questionnaireItemHeader}>
                                        <span>{t('common.substantive.fhImmunologicAssessmentDisease')} #{i + 1}</span>
                                        <IconButton aria-label="delete" color="inherit" onClick={props.onFhRemove('immunologic', i)} >
                                            <DeleteIcon />
                                        </IconButton>
                                    </Grid>
                                    <Grid item xs={12} md={12} className={classes.appSelectGridItem}>
                                        <AppSelect
                                            id={`immunologic${i + 1}`}
                                            value={immunologic.disease}
                                            label="Condition"
                                            items={[...immunologicDiseases]}
                                            onChange={e => props.onFhDataChange('immunologic', i, 'disease', e.target.value)()}
                                            error={props.submitted && !props.validator.fieldValid(`immunologic_#${i + 1}_disease`)}
                                            helperText={props.validator.message(`immunologic_#${i + 1}_disease`, immunologic.disease, 'required')}
                                            fullWidth
                                        />
                                    </Grid>
                                    <Box style={{ width: "100%" }} display={immunologic.disease === 'None' || immunologic.disease === '' ? 'none' : 'block'}>
                                        <Grid item xs={12}>
                                            <Typography variant="h6">Family Members</Typography>
                                            <FormControl variant="outlined" fullWidth>
                                                <Select
                                                    multiple
                                                    value={immunologic.heirs}
                                                    onChange={e => props.onFhDataChange('immunologic', i, 'heirs', e.target.value)()}
                                                    renderValue={(selected) => selected.join(", ")}
                                                    MenuProps={MenuProps}
                                                    error={props.submitted && !props.validator.fieldValid(`immunologic_#${i + 1}_heirs`)}>
                                                    {familyHeirs.map((option) => (
                                                        <MenuItem key={option} value={option}>
                                                            <ListItemIcon>
                                                                <Checkbox color="primary" checked={immunologic.heirs.indexOf(option) > -1} />
                                                            </ListItemIcon>
                                                            <ListItemText primary={option} />
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                                <FormHelperText error>
                                                    {props.validator.message(`immunologic_#${i + 1}_heirs`, immunologic.heirs, 'required')}
                                                </FormHelperText>
                                            </FormControl>
                                            <FormControl
                                                component="fieldset"
                                                error={props.submitted && !props.validator.fieldValid(`immunologic_#${i + 1}_self`)}>
                                                <FormLabel className={classes.formLabelStyle}>{`${t('common.substantive.self')}*`}</FormLabel>
                                                <RadioGroup row
                                                    aria-label="Self"
                                                    value={immunologic.self}
                                                    onChange={e => props.onFhDataChange('immunologic', i, 'self', e.target.value)()}
                                                >
                                                    {['Yes', 'No'].map((answer, i) =>
                                                        <FormControlLabel key={i} value={answer} control={<Radio color="primary" />} label={answer} />
                                                    )}
                                                </RadioGroup>
                                                <FormHelperText>
                                                    {props.validator.message(`immunologic_#${i + 1}_self`, immunologic.self, 'required')}
                                                </FormHelperText>
                                            </FormControl>
                                        </Grid>
                                    </Box>
                                </Grid>
                            )
                        })}
                        <Grid item xs={12} style={{ marginBottom: 15 }}>
                            <Button
                                fullWidth
                                variant="contained"
                                onClick={props.onFhAdd('immunologic')}
                                color="secondary"
                                startIcon={<AddIcon />}
                            >
                                {t('module.provider.addPatient.form.button.addImmunologicAssessment')}
                            </Button>
                        </Grid>

                        {/* neurologic */}
                        {props.fhNeurologic?.map((neurologic, i) => {
                            return (
                                <Grid container style={{ paddingTop: 10 }} spacing={1} className={classes.questionnaireItem} key={i}>
                                    <Grid item xs={12} className={classes.questionnaireItemHeader}>
                                        <span>{t('common.substantive.fhNeurologicAssessmentDisease')} #{i + 1}</span>
                                        <IconButton aria-label="delete" color="inherit" onClick={props.onFhRemove('neurologic', i)} >
                                            <DeleteIcon />
                                        </IconButton>
                                    </Grid>
                                    <Grid item xs={12} md={12} className={classes.appSelectGridItem}>
                                        <AppSelect
                                            id={`neurologic${i + 1}`}
                                            value={neurologic.disease}
                                            label="Condition"
                                            items={[...neurologicDiseases]}
                                            onChange={e => props.onFhDataChange('neurologic', i, 'disease', e.target.value)()}
                                            error={props.submitted && !props.validator.fieldValid(`neurologic_#${i + 1}_disease`)}
                                            helperText={props.validator.message(`neurologic_#${i + 1}_disease`, neurologic.disease, 'required')}
                                            fullWidth
                                        />
                                    </Grid>
                                    <Box style={{ width: "100%" }} display={neurologic.disease === 'None' || neurologic.disease === '' ? 'none' : 'block'}>
                                        <Grid item xs={12}>
                                            <Typography variant="h6">Family Members</Typography>
                                            <FormControl variant="outlined" fullWidth>
                                                <Select
                                                    multiple
                                                    value={neurologic.heirs}
                                                    onChange={e => props.onFhDataChange('neurologic', i, 'heirs', e.target.value)()}
                                                    renderValue={(selected) => selected.join(", ")}
                                                    MenuProps={MenuProps}
                                                    error={props.submitted && !props.validator.fieldValid(`neurologic_#${i + 1}_heirs`)}>
                                                    {familyHeirs.map((option) => (
                                                        <MenuItem key={option} value={option}>
                                                            <ListItemIcon>
                                                                <Checkbox color="primary" checked={neurologic.heirs.indexOf(option) > -1} />
                                                            </ListItemIcon>
                                                            <ListItemText primary={option} />
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                                <FormHelperText error>
                                                    {props.validator.message(`neurologic_#${i + 1}_heirs`, neurologic.heirs, 'required')}
                                                </FormHelperText>
                                            </FormControl>
                                            <FormControl
                                                component="fieldset"
                                                error={props.submitted && !props.validator.fieldValid(`neurologic_#${i + 1}_self`)}>
                                                <FormLabel className={classes.formLabelStyle}>{`${t('common.substantive.self')}*`}</FormLabel>
                                                <RadioGroup row
                                                    aria-label="Self"
                                                    value={neurologic.self}
                                                    onChange={e => props.onFhDataChange('neurologic', i, 'self', e.target.value)()}
                                                >
                                                    {['Yes', 'No'].map((answer, i) =>
                                                        <FormControlLabel key={i} value={answer} control={<Radio color="primary" />} label={answer} />
                                                    )}
                                                </RadioGroup>
                                                <FormHelperText>
                                                    {props.validator.message(`neurologic_#${i + 1}_self`, neurologic.self, 'required')}
                                                </FormHelperText>
                                            </FormControl>
                                        </Grid>
                                    </Box>
                                </Grid>
                            )
                        })}
                        <Grid item xs={12} style={{ marginBottom: 15 }}>
                            <Button
                                fullWidth
                                variant="contained"
                                onClick={props.onFhAdd('neurologic')}
                                color="secondary"
                                startIcon={<AddIcon />}
                            >
                                {t('module.provider.addPatient.form.button.addNeurologicAssessment')}
                            </Button>
                        </Grid>


                        {/* oncologic */}
                        {props.fhOncologic?.map((oncologic, i) => {
                            return (
                                <Grid container style={{ paddingTop: 10 }} spacing={1} className={classes.questionnaireItem} key={i}>
                                    <Grid item xs={12} className={classes.questionnaireItemHeader}>
                                        <span>{t('common.substantive.fhOncologicAssessmentDisease')} #{i + 1}</span>
                                        <IconButton aria-label="delete" color="inherit" onClick={props.onFhRemove('oncologic', i)} >
                                            <DeleteIcon />
                                        </IconButton>
                                    </Grid>
                                    <Grid item xs={12} md={12} className={classes.appSelectGridItem}>
                                        <AppSelect
                                            id={`oncologic${i + 1}`}
                                            value={oncologic.disease}
                                            label="Condition"
                                            items={[...oncologicDiseases,'Other']}
                                            onChange={e => {
                                                props.onFhDataChange('oncologic', i, 'disease', e.target.value)();
                                                oncologic.othersiteofOncologic = ''
                                            }}
                                            error={props.submitted && !props.validator.fieldValid(`oncologic_#${i + 1}_disease`)}
                                            helperText={props.validator.message(`oncologic_#${i + 1}_disease`, oncologic.disease, 'required')}

                                            
                                            fullWidth
                                        />
                                    </Grid>

                                    <Grid item xs={12} className={classes.appSelectGridItem}>
                                                <Box display={oncologic.disease === 'Other' ? 'block' : 'none'}>
                                                    <TextField
                                                        label="Describe the other site of cancer*"
                                                        variant="outlined"
                                                        fullWidth
                                                        margin="normal"
                                                        inputProps={{ style: { maxLength: 500 } }}
                                                        value={oncologic.othersiteofOncologic}
                                                        onChange={props.onDataChange(i, 'othersiteofOncologic')}
                                                        error={props.submitted && !props.validator.fieldValid(`oncology_#${i + 1}_other_site_of_oncologic`)}
                                                        helperText={props.validator.message(`oncology_#${i + 1}_other_site_of_oncologic`, oncologic.othersiteofOncologic, `other_site_of_oncologic:${oncologic.disease}`)}
                                                       
                                                       
                                                    />
                                                </Box>
                                            </Grid>

                                    <Box style={{ width: "100%" }} display={oncologic.disease === 'None' || oncologic.disease === '' ? 'none' : 'block'}>
                                        <Grid item xs={12}>
                                            <Typography variant="h6">Family Members</Typography>
                                            <FormControl variant="outlined" fullWidth>
                                                <Select
                                                    multiple
                                                    value={oncologic.heirs}
                                                    onChange={e => props.onFhDataChange('oncologic', i, 'heirs', e.target.value)()}
                                                    renderValue={(selected) => selected.join(", ")}
                                                    MenuProps={MenuProps}
                                                    error={props.submitted && !props.validator.fieldValid(`oncologic_#${i + 1}_heirs`)}>
                                                    {familyHeirs.map((option) => (
                                                        <MenuItem key={option} value={option}>
                                                            <ListItemIcon>
                                                                <Checkbox color="primary" checked={oncologic.heirs.indexOf(option) > -1} />
                                                            </ListItemIcon>
                                                            <ListItemText primary={option} />
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                                <FormHelperText error>
                                                    {props.validator.message(`oncologic_#${i + 1}_heirs`, oncologic.heirs, 'required')}
                                                </FormHelperText>
                                            </FormControl>
                                            <FormControl
                                                component="fieldset"
                                                error={props.submitted && !props.validator.fieldValid(`oncologic_#${i + 1}_self`)}>
                                                <FormLabel className={classes.formLabelStyle}>{`${t('common.substantive.self')}*`}</FormLabel>
                                                <RadioGroup row
                                                    aria-label="Self"
                                                    value={oncologic.self}
                                                    onChange={e => props.onFhDataChange('oncologic', i, 'self', e.target.value)()}
                                                >
                                                    {['Yes', 'No'].map((answer, i) =>
                                                        <FormControlLabel key={i} value={answer} control={<Radio color="primary" />} label={answer} />
                                                    )}
                                                </RadioGroup>
                                                <FormHelperText>
                                                    {props.validator.message(`oncologic_#${i + 1}_self`, oncologic.self, 'required')}
                                                </FormHelperText>
                                            </FormControl>
                                        </Grid>
                                    </Box>
                                </Grid>
                            )
                        })}
                        <Grid item xs={12} style={{ marginBottom: 15 }}>
                            <Button
                                fullWidth
                                variant="contained"
                                onClick={props.onFhAdd('oncologic')}
                                color="secondary"
                                startIcon={<AddIcon />}
                            >
                                {t('module.provider.addPatient.form.button.addOncologicAssessment')}
                            </Button>
                        </Grid>


                        {/* psychiatric */}
                        {props.fhPsychiatric?.map((psychiatric, i) => {
                            return (
                                <Grid container style={{ paddingTop: 10 }} spacing={1} className={classes.questionnaireItem} key={i}>
                                    <Grid item xs={12} className={classes.questionnaireItemHeader}>
                                        <span>{t('common.substantive.fhPsychiatricAssessmentDisease')} #{i + 1}</span>
                                        <IconButton aria-label="delete" color="inherit" onClick={props.onFhRemove('psychiatric', i)} >
                                            <DeleteIcon />
                                        </IconButton>
                                    </Grid>
                                    <Grid item xs={12} md={12} className={classes.appSelectGridItem}>
                                        <AppSelect
                                            id={`psychiatric${i + 1}`}
                                            value={psychiatric.disease}
                                            label="Condition"
                                            items={[...psychiatricDiseases]}
                                            onChange={e => props.onFhDataChange('psychiatric', i, 'disease', e.target.value)()}
                                            error={props.submitted && !props.validator.fieldValid(`psychiatric_#${i + 1}_disease`)}
                                            helperText={props.validator.message(`psychiatric_#${i + 1}_disease`, psychiatric.disease, 'required')}
                                            fullWidth
                                        />
                                    </Grid>
                                    <Box style={{ width: "100%" }} display={psychiatric.disease === 'None' || psychiatric.disease === '' ? 'none' : 'block'}>
                                        <Grid item xs={12}>
                                            <Typography variant="h6">Family Members</Typography>
                                            <FormControl variant="outlined" fullWidth>
                                                <Select
                                                    multiple
                                                    value={psychiatric.heirs}
                                                    onChange={e => props.onFhDataChange('psychiatric', i, 'heirs', e.target.value)()}
                                                    renderValue={(selected) => selected.join(", ")}
                                                    MenuProps={MenuProps}
                                                    error={props.submitted && !props.validator.fieldValid(`psychiatric_#${i + 1}_heirs`)}>
                                                    {familyHeirs.map((option) => (
                                                        <MenuItem key={option} value={option}>
                                                            <ListItemIcon>
                                                                <Checkbox color="primary" checked={psychiatric.heirs.indexOf(option) > -1} />
                                                            </ListItemIcon>
                                                            <ListItemText primary={option} />
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                                <FormHelperText error>
                                                    {props.validator.message(`psychiatric_#${i + 1}_heirs`, psychiatric.heirs, 'required')}
                                                </FormHelperText>
                                            </FormControl>
                                            <FormControl
                                                component="fieldset"
                                                error={props.submitted && !props.validator.fieldValid(`psychiatric_#${i + 1}_self`)}>
                                                <FormLabel className={classes.formLabelStyle}>{`${t('common.substantive.self')}*`}</FormLabel>
                                                <RadioGroup row
                                                    aria-label="Self"
                                                    value={psychiatric.self}
                                                    onChange={e => props.onFhDataChange('psychiatric', i, 'self', e.target.value)()}
                                                >
                                                    {['Yes', 'No'].map((answer, i) =>
                                                        <FormControlLabel key={i} value={answer} control={<Radio color="primary" />} label={answer} />
                                                    )}
                                                </RadioGroup>
                                                <FormHelperText>
                                                    {props.validator.message(`psychiatric_#${i + 1}_self`, psychiatric.self, 'required')}
                                                </FormHelperText>
                                            </FormControl>
                                        </Grid>
                                    </Box>
                                </Grid>
                            )
                        })}
                        <Grid item xs={12} style={{ marginBottom: 15 }}>
                            <Button
                                fullWidth
                                variant="contained"
                                onClick={props.onFhAdd('psychiatric')}
                                color="secondary"
                                startIcon={<AddIcon />}
                            >
                                {t('module.provider.addPatient.form.button.addPsychiatricAssessment')}
                            </Button>
                        </Grid>


                        {/* respiratory */}
                        {props.fhRespiratory?.map((respiratory, i) => {
                            return (
                                <Grid container style={{ paddingTop: 10 }} spacing={1} className={classes.questionnaireItem} key={i}>
                                    <Grid item xs={12} className={classes.questionnaireItemHeader}>
                                        <span>{t('common.substantive.fhRespiratoryAssessmentDisease')} #{i + 1}</span>
                                        <IconButton aria-label="delete" color="inherit" onClick={props.onFhRemove('respiratory', i)} >
                                            <DeleteIcon />
                                        </IconButton>
                                    </Grid>
                                    <Grid item xs={12} md={12} className={classes.appSelectGridItem}>
                                        <AppSelect
                                            id={`respiratory${i + 1}`}
                                            value={respiratory.disease}
                                            label="Condition"
                                            items={[...respiratoryDiseases]}
                                            onChange={e => props.onFhDataChange('respiratory', i, 'disease', e.target.value)()}
                                            error={props.submitted && !props.validator.fieldValid(`respiratory_#${i + 1}_disease`)}
                                            helperText={props.validator.message(`respiratory_#${i + 1}_disease`, respiratory.disease, 'required')}
                                            fullWidth
                                        />
                                    </Grid>
                                    <Box style={{ width: "100%" }} display={respiratory.disease === 'None' || respiratory.disease === '' ? 'none' : 'block'}>
                                        <Grid item xs={12}>
                                            <Typography variant="h6">Family Members</Typography>
                                            <FormControl variant="outlined" fullWidth>
                                                <Select
                                                    multiple
                                                    value={respiratory.heirs}
                                                    onChange={e => props.onFhDataChange('respiratory', i, 'heirs', e.target.value)()}
                                                    renderValue={(selected) => selected.join(", ")}
                                                    MenuProps={MenuProps}
                                                    error={props.submitted && !props.validator.fieldValid(`respiratory_#${i + 1}_heirs`)}>
                                                    {familyHeirs.map((option) => (
                                                        <MenuItem key={option} value={option}>
                                                            <ListItemIcon>
                                                                <Checkbox color="primary" checked={respiratory.heirs.indexOf(option) > -1} />
                                                            </ListItemIcon>
                                                            <ListItemText primary={option} />
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                                <FormHelperText error>
                                                    {props.validator.message(`respiratory_#${i + 1}_heirs`, respiratory.heirs, 'required')}
                                                </FormHelperText>
                                            </FormControl>
                                            <FormControl
                                                component="fieldset"
                                                error={props.submitted && !props.validator.fieldValid(`respiratory_#${i + 1}_self`)}>
                                                <FormLabel className={classes.formLabelStyle}>{`${t('common.substantive.self')}*`}</FormLabel>
                                                <RadioGroup row
                                                    aria-label="Self"
                                                    value={respiratory.self}
                                                    onChange={e => props.onFhDataChange('respiratory', i, 'self', e.target.value)()}
                                                >
                                                    {['Yes', 'No'].map((answer, i) =>
                                                        <FormControlLabel key={i} value={answer} control={<Radio color="primary" />} label={answer} />
                                                    )}
                                                </RadioGroup>
                                                <FormHelperText>
                                                    {props.validator.message(`respiratory_#${i + 1}_self`, respiratory.self, 'required')}
                                                </FormHelperText>
                                            </FormControl>
                                        </Grid>
                                    </Box>
                                </Grid>
                            )
                        })}
                        <Grid item xs={12} style={{ marginBottom: 15 }}>
                            <Button
                                fullWidth
                                variant="contained"
                                onClick={props.onFhAdd('respiratory')}
                                color="secondary"
                                startIcon={<AddIcon />}
                            >
                                {t('module.provider.addPatient.form.button.addRespiratoryAssessment')}
                            </Button>
                        </Grid>


                        {/* reproductive */}
                        {props.fhReproductive?.map((reproductive, i) => {
                            return (
                                <Grid container style={{ paddingTop: 10 }} spacing={1} className={classes.questionnaireItem} key={i}>
                                    <Grid item xs={12} className={classes.questionnaireItemHeader}>
                                        <span>{t('common.substantive.fhReproductiveAssessmentDisease')} #{i + 1}</span>
                                        <IconButton aria-label="delete" color="inherit" onClick={props.onFhRemove('reproductive', i)} >
                                            <DeleteIcon />
                                        </IconButton>
                                    </Grid>
                                    <Grid item xs={12} md={12} className={classes.appSelectGridItem}>
                                        <AppSelect
                                            id={`reproductive${i + 1}`}
                                            value={reproductive.disease}
                                            label="Condition"
                                            items={[...reproductiveDiseases]}
                                            onChange={e => props.onFhDataChange('reproductive', i, 'disease', e.target.value)()}
                                            error={props.submitted && !props.validator.fieldValid(`reproductive_#${i + 1}_disease`)}
                                            helperText={props.validator.message(`reproductive_#${i + 1}_disease`, reproductive.disease, 'required')}
                                            fullWidth
                                        />
                                    </Grid>
                                    <Box style={{ width: "100%" }} display={reproductive.disease === 'None' || reproductive.disease === '' ? 'none' : 'block'}>
                                        <Grid item xs={12}>
                                            <Typography variant="h6">Family Members</Typography>
                                            <FormControl variant="outlined" fullWidth>
                                                <Select
                                                    multiple
                                                    value={reproductive.heirs}
                                                    onChange={e => props.onFhDataChange('reproductive', i, 'heirs', e.target.value)()}
                                                    renderValue={(selected) => selected.join(", ")}
                                                    MenuProps={MenuProps}
                                                    error={props.submitted && !props.validator.fieldValid(`reproductive_#${i + 1}_heirs`)}>
                                                    {familyHeirs.map((option) => (
                                                        <MenuItem key={option} value={option}>
                                                            <ListItemIcon>
                                                                <Checkbox color="primary" checked={reproductive.heirs.indexOf(option) > -1} />
                                                            </ListItemIcon>
                                                            <ListItemText primary={option} />
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                                <FormHelperText error>
                                                    {props.validator.message(`reproductive_#${i + 1}_heirs`, reproductive.heirs, 'required')}
                                                </FormHelperText>
                                            </FormControl>
                                            <FormControl
                                                component="fieldset"
                                                error={props.submitted && !props.validator.fieldValid(`reproductive_#${i + 1}_self`)}>
                                                <FormLabel className={classes.formLabelStyle}>{`${t('common.substantive.self')}*`}</FormLabel>
                                                <RadioGroup row
                                                    aria-label="Self"
                                                    value={reproductive.self}
                                                    onChange={e => props.onFhDataChange('reproductive', i, 'self', e.target.value)()}
                                                >
                                                    {['Yes', 'No'].map((answer, i) =>
                                                        <FormControlLabel key={i} value={answer} control={<Radio color="primary" />} label={answer} />
                                                    )}
                                                </RadioGroup>
                                                <FormHelperText>
                                                    {props.validator.message(`reproductive_#${i + 1}_self`, reproductive.self, 'required')}
                                                </FormHelperText>
                                            </FormControl>
                                        </Grid>
                                    </Box>
                                </Grid>
                            )
                        })}
                        <Grid item xs={12} style={{ marginBottom: 15 }}>
                            <Button
                                fullWidth
                                variant="contained"
                                onClick={props.onFhAdd('reproductive')}
                                color="secondary"
                                startIcon={<AddIcon />}
                            >
                                {t('module.provider.addPatient.form.button.addReproductiveAssessment')}
                            </Button>
                        </Grid>
                    </Grid >
                </AccordionDetails>
            </Accordion>
        </Grid >
    )
}

export default FamilyHistory;